module.exports = __webpack_public_path__ + "static/aum-4c8a29453c2c5c838582d57073659a3a.jpg";